import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import { t } from '../../../utils/translations';
import { formatDate } from '../../../utils/dateUtils';

const AutoSaveIndicator = ({ lastSaved, isSaving, hasUnsavedChanges }) => {
  const [timeAgo, setTimeAgo] = useState('');

  useEffect(() => {
    if (!lastSaved) return;

    const updateTimeAgo = () => {
      const now = new Date();
      const diff = now - lastSaved;
      const seconds = Math.floor(diff / 1000);
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);

      if (seconds < 60) {
        setTimeAgo(t('autoSave.justNow'));
      } else if (minutes < 60) {
        setTimeAgo(t('autoSave.minAgo', { minutes }));
      } else if (hours < 24) {
        setTimeAgo(hours === 1 ? t('autoSave.hourAgo') : t('autoSave.hoursAgo', { hours }));
      } else {
        setTimeAgo(formatDate(lastSaved));
      }
    };

    updateTimeAgo();
    const interval = setInterval(updateTimeAgo, 30000); // Update every 30 seconds

    return () => clearInterval(interval);
  }, [lastSaved]);

  const getStatusIcon = () => {
    if (isSaving) return 'Loader2';
    if (hasUnsavedChanges) return 'AlertCircle';
    return 'CheckCircle';
  };

  const getStatusColor = () => {
    if (isSaving) return 'text-accent';
    if (hasUnsavedChanges) return 'text-warning';
    return 'text-success';
  };

  const getStatusText = () => {
    if (isSaving) return t('autoSave.saving');
    if (hasUnsavedChanges) return t('autoSave.unsavedChanges');
    return t('autoSave.saved', { timeAgo });
  };

  return (
    <div className="flex items-center space-x-2 text-sm">
      <Icon 
        name={getStatusIcon()} 
        size={16} 
        className={`${getStatusColor()} ${isSaving ? 'animate-spin' : ''}`}
      />
      <span className={getStatusColor()}>
        {getStatusText()}
      </span>
    </div>
  );
};

export default AutoSaveIndicator;